import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const metricsApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.metricsApiUrl) || !environment.metricsApiKey) {
    return next(req);
  }

  return next(req.clone({
    setHeaders: { 'X-API-Key': environment.metricsApiKey },
  }));
};
